import React, { useState, useEffect, useContext } from 'react';
import io from 'socket.io-client';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import LoadingComponent from '../common/LoadingComponent';

import config from '../../config';
// console.log('slidesConfigData', slidesConfigData);

const PresenterOrAttendeeContext = React.createContext(null);

const UNIQUEATTENDEEID = 'UNIQUEATTENDEEID';
export const AttendeeAndPresenterProvider = ({ children, meetingId }) => {
  const [connected, setConnected] = useState(false);
  const [socket, setSocket] = useState();
  const [gameState, setGameState] = useState({});
  const [questions, setQuestions] = useState({});
  const [questionIds, setQuestionIds] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [userAnswers, setUserAnswers] = useState({});
  const [attendeeId, setAttendeeId] = useState('123');

  const [prevQuestion, setPrevQuestion] = useState('initial');

  useEffect(() => {
    // we need to emit a get session
    const newSocket = io.connect(config.baseUrl);
    setSocket(newSocket);
    if (sessionStorage.getItem(UNIQUEATTENDEEID)) {
      setAttendeeId(sessionStorage.getItem(UNIQUEATTENDEEID));
    } else {
      const newAttendeeId = uuidv4();
      setAttendeeId(newAttendeeId);
      sessionStorage.setItem(UNIQUEATTENDEEID, newAttendeeId);
    }

    if (meetingId === null || meetingId === undefined) {
      return;
    }

    newSocket.on('connect', () => {
      newSocket.emit('join', `ARS${meetingId}`);
      console.log('connecting', meetingId);
      newSocket.emit('getState', meetingId);
      newSocket.emit('getQuestions', meetingId);

      setConnected(true);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('in socket useEffect', socket);
    if (socket) {
      socket.on('gameState', (gameStateData) => {
        setGameState(gameStateData);
      });

      socket.on('questions', (questionsData) => {
        // console.log('questionsData', questionsData);
        setQuestionIds(_.map(questionsData, 'id'));
        setQuestions(_.keyBy(questionsData, 'id'));
      });

      socket.on('currentQuestion', (currentQuestionId) => {
        // console.log('currentQuestionId', currentQuestionId);
        setCurrentQuestion(questions[currentQuestionId]);
      });

      socket.on('userAnswers', (userAnswers) => {
        // console.log('ZZZZZZ userAnswers', userAnswers);
        setUserAnswers(userAnswers);
      });

      socket.on('resetAnswers', () => {
        setUserAnswers({});
      });

      socket.on('disconnect', () => {
        setConnected(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  useEffect(() => {
    // console.log(
    //   'in gameState useEffect',
    //   'gamestate:',
    //   gameState,
    //   'questions',
    //   questions,
    //   'questionIds:',
    //   questionIds,
    //   'currentQuestion',
    //   currentQuestion
    // );
    if ((gameState.questionId && questions && !currentQuestion) || gameState.questionId !== currentQuestion?.id) {
      // console.log('setting currentQuestion', gameState.questionId,questions[gameState.questionId]);
      setCurrentQuestion(questions[gameState.questionId]);
    }
  }, [gameState, questions, questionIds, currentQuestion]);

  const startGame = () => {
    socket.emit('startGame', { meetingId, questionId: questionIds[0] });
  };

  const nextQuestion = () => {
    if (questionIds.indexOf(currentQuestion.id) + 1 >= questionIds.length) {
      endGame();
    } else {
      const nextQuestionId = questionIds[questionIds.indexOf(currentQuestion.id) + 1];
      // console.error(nextQuestionId)
      setUserAnswers({});
      resetAnswers();
      socket.emit('nextQuestion', { nextQuestionId, meetingId });
    }
  };

  const resetAnswers = () => {
    socket.emit('resetAnswers', { meetingId });
  };

  const openQuestion = () => {
    // console.log(currentQuestion.id)
    socket.emit('openQuestion', { meetingId });
  };

  const closeQuestion = () => {
    // if its the last question we should jsut end the game
    setPrevQuestion(currentQuestion.id);
    socket.emit('closeQuestion', { meetingId });
  };

  const submitResponse = (answerId, questionId) => {
    console.log('submitResponse', answerId, questionId, attendeeId);
    socket.emit('submitResponse', { meetingId, answerId, questionId, attendeeId, category: currentQuestion.category });
  };

  const endGame = () => {
    setPrevQuestion('initial');
    // setUserAnswers({});
    resetAnswers();
    socket.emit('endGame', { meetingId });
  };

  const resetGame = () => {
    setPrevQuestion('initial');
    // setUserAnswers({});
    resetAnswers();
    socket.emit('resetGame', { meetingId });
  };

  if (connected) {
    return (
      <PresenterOrAttendeeContext.Provider
        value={{
          socket,
          gameState,
          questions,
          currentQuestion,
          startGame,
          nextQuestion,
          openQuestion,
          closeQuestion,
          prevQuestion,
          submitResponse,
          endGame,
          resetGame,
          userAnswers,
          attendeeId,
          questionIds
        }}
      >
        {children}
      </PresenterOrAttendeeContext.Provider>
    );
  }
  return <LoadingComponent />;
};

export const usePresenterOrAttendee = () => {
  const store = useContext(PresenterOrAttendeeContext);
  return store;
};
